import { render, staticRenderFns } from "./tabMaterialsStock.vue?vue&type=template&id=7fbcb538&"
import script from "./tabMaterialsStock.vue?vue&type=script&lang=js&"
export * from "./tabMaterialsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports